module.exports = __webpack_public_path__ + "static/img/ywc.92f6e5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ywc.svg
// module id = RtwJ
// module chunks = 1 2